import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';

import { Compbaser } from '../compbaser';
import { SceneCardTemplateService, ISceneTemplate, ITemplateResolution, ITemplateCategory } from '../../services/scene-card-template.service';
import { CardSceneCreatorService } from '../../services/card-scene-creator.service';
import { ISceneBlock } from '../../interfaces';

export interface DialogSceneCardBrowserData {
    selectedTemplate?: ISceneTemplate;
}

export interface DialogSceneCardBrowserResult {
    template: ISceneTemplate;
    scene: { Player: ISceneBlock };
}

@Component({
    selector: 'app-dialog-scene-card-browser',
    templateUrl: './dialog-scene-card-browser.component.html',
    styleUrls: ['./dialog-scene-card-browser.component.scss'],
    standalone: false
})
export class DialogSceneCardBrowserComponent extends Compbaser implements OnInit {
    selectedTemplate: ISceneTemplate | null = null;
    filteredTemplates: ISceneTemplate[] = [];
    allTemplates: ISceneTemplate[] = [];
    searchQuery = '';
    loading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogSceneCardBrowserData,
        private dialogRef: MatDialogRef<DialogSceneCardBrowserComponent>,
        public override dialog: MatDialog,
        private sceneCardTemplateService: SceneCardTemplateService,
        private cardSceneCreatorService: CardSceneCreatorService,
        private translocoService: TranslocoService
    ) {
        super(dialog);
        if (data?.selectedTemplate) {
            this.selectedTemplate = data.selectedTemplate;
        }
    }

    ngOnInit(): void {
        this.allTemplates = this.sceneCardTemplateService.getTemplates();
        this.filteredTemplates = [...this.allTemplates];
    }

    selectTemplate(template: ISceneTemplate): void {
        this.selectedTemplate = template;
    }

    onSearchChange(): void {
        if (this.searchQuery.trim()) {
            this.filteredTemplates = this.sceneCardTemplateService.searchTemplates(this.searchQuery);
        } else {
            this.filteredTemplates = [...this.allTemplates];
        }
    }

    clearSearch(): void {
        this.searchQuery = '';
        this.onSearchChange();
    }

    async applyTemplate() {
        if (this.selectedTemplate) {
            this.loading = true;

            try {
                this.sceneCardTemplateService.setCurrentTemplate(this.selectedTemplate);

                // Create the actual scene from the template
                const scene = await this.cardSceneCreatorService.createSceneFromTemplate(this.selectedTemplate);

                // Return both template and scene
                this.dialogRef.close({
                    template: this.selectedTemplate,
                    scene: scene
                });
            } catch (error) {
                console.error('Error applying template:', error);
                this.loading = false;
            }
        }
    }

    cancel(): void {
        this.dialogRef.close();
    }

    getRandomTemplate(): void {
        this.selectedTemplate = this.sceneCardTemplateService.getRandomTemplate();
    }

    getCategoryInfo(category: string): ITemplateCategory | undefined {
        return this.sceneCardTemplateService.getCategoryInfo(category);
    }

    getResolutionInfo(resolution: string): ITemplateResolution | undefined {
        return this.sceneCardTemplateService.getResolutionInfo(resolution);
    }
}
